/**
 * Centralized base paths for application assets.
 * Used by component-specific media modules to resolve image and video URLs.
 * Keeps asset references consistent and maintainable across the app.
 */

export const BASE_IMAGES = "/assets/images";
export const BASE_VIDEOS = "/assets/videos/";